import i18n from "i18n";

const headers = {
  name: {
    name: 'name',
    title: i18n.t("name").toUpperCase(),
    active: false,
    direction: false
  },
  type: {
    name: 'type',
    title: i18n.t("type").toUpperCase(),
    mobileTag: false,
    pill: true,
    pillMap: {
      BOX: i18n.t("box"),
      PALLET: i18n.t("palets"),
    },
    pillMapColor: {
      BOX: '#3C7AF5',
      PALLET: '#3C7AF5',
    },
  },
  quantity: {
    name: 'quantity',
    title: i18n.t("quantity").toUpperCase(),
    active: false,
    direction: false
  },
  product: {
    name: 'product',
    title: i18n.t("product").toUpperCase(),
    active: false,
    direction: false
  },
}

export default headers;